export enum Paths {
  Login = '/login',
  LoginNext = '/login/continue',
  LoginOtp = '/login/otp',
  SsoLogin = '/sso_login',
  SsoLogout = '/sso_logout',
  AccountBlocked = '/account-blocked',
  DemoBlocked = '/demo-blocked',
  ForgotPassword = '/password/forgot',
  ForgotPasswordOtp = '/password/forgot/otp',
  ResetPassword = '/password/reset',
  ResetPasswordSuccess = '/password/reset/success',
  Signup = '/signup',
  SignupOtp = '/signup/otp',
  SignupSuccess = '/signup/success',
  RequestDemo = '/request-demo',
  RequestDemoSuccess = '/request-demo/success',
  Root = '/',
  Home = '/member/home',
  HomeDashboard = '/member/home/dashboard',
  HomeBinary = '/member/home/binary',
  HomePackage = '/member/home/package',
  HomeRank = '/member/home/rank',
  DownlineJoinings = '/member/downlines',
  ReferralJoinings = '/member/referral/joinings',
  PvHistory = '/member/pv-history',
  Referral = '/member/referral',
  ReferralSummary = '/member/referral/summary',
  ReferralRecruiter = '/member/referral/recruiter',
  ReferralEarner = '/member/referral/earner',
  Wallet = '/member/wallet',
  WalletStatement = '/member/wallet/statement',
  WalletEarning = '/member/wallet/earning',
  WalletPayout = '/member/wallet/payout',
  RequestPayout = '/member/wallet/request-payout',
  TransactionHistory = '/member/wallet/transactions',
  EarningHistory = '/member/wallet/recent-earnings',
  PayoutHistory = '/member/wallet/recent-payouts',
  Network = '/member/network',
  NetworkGenealogy = '/member/network/genealogy',
  NetworkTabular = '/member/network/tabular',
  NetworkDownline = '/member/network/downline',
  Account = '/member/account',
  Kyc = '/member/kyc',
  Crm = '/member/crm',
  CrmDashboard = '/member/crm/dashboard',
  CrmAnalytics = '/member/crm/analytics',
  Mail = '/member/mail',
  MailInbox = '/member/mail/inbox',
  MailSent = '/member/mail/sent',
  MailSentItem = '/member/mail/sent-item',
  MailCompose = '/member/mail/compose',
  MailConversation = '/member/mail/conversation',
  Notification = '/member/notifications',
  Story = '/member/story',
  StoryArticle = '/member/story/article',
  StoryVideo = '/member/story/video',
  ArticleDetail = '/member/story/article',
  VideoDetail = '/member/story/video',
  Events = '/member/events',
  EventDetail = '/member/event',
  Support = '/member/support',
  Order = '/member/order',
  MemberSignup = '/member/signup',
  MemberSignupOtp = '/member/signup/otp',
  ProfileBasic = '/member/account/basic',
  ProfileEmail = '/member/account/email',
  ProfileEmailOtp = '/member/account/email/otp',
  ProfilePhone = '/member/account/phone',
  ProfilePhoneOtp = '/member/account/phone/otp',
  ProfileBank = '/member/account/bank',
  ChangePassword = '/member/account/password',
  ChangeWalletPassword = '/member/account/wallet-password',
  ProfilePayout = '/member/account/payout',
  ProfileLanguage = '/member/account/language',
  ProfileCurrency = '/member/account/currency',
  ProfileDateFormat = '/member/account/date-format',
  ProfileNotification = '/member/account/notification',
  ProfilePushNotification = '/member/account/notification/push',
  ProfileEmailNotification = '/member/account/notification/email',
  IntroVideo = '/member/account/intro-video',
  Faqs = '/member/account/faqs',
  More = '/member/account/more',
}
